import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const VCardIcon = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M6.25 8C7.63071 8 8.75 6.88071 8.75 5.5C8.75 4.11929 7.63071 3 6.25 3C4.86929 3 3.75 4.11929 3.75 5.5C3.75 6.88071 4.86929 8 6.25 8Z",
    fill: color
  }), __jsx("path", {
    d: "M11.25 4.875C11.25 4.52982 11.5298 4.25 11.875 4.25H16.875C17.2202 4.25 17.5 4.52982 17.5 4.875C17.5 5.22018 17.2202 5.5 16.875 5.5H11.875C11.5298 5.5 11.25 5.22018 11.25 4.875Z",
    fill: color
  }), __jsx("path", {
    d: "M11.25 8C11.25 7.65482 11.5298 7.375 11.875 7.375H16.875C17.2202 7.375 17.5 7.65482 17.5 8C17.5 8.34518 17.2202 8.625 16.875 8.625H11.875C11.5298 8.625 11.25 8.34518 11.25 8Z",
    fill: color
  }), __jsx("path", {
    d: "M12.5 11.125C12.5 10.7798 12.7798 10.5 13.125 10.5H16.875C17.2202 10.5 17.5 10.7798 17.5 11.125C17.5 11.4702 17.2202 11.75 16.875 11.75H13.125C12.7798 11.75 12.5 11.4702 12.5 11.125Z",
    fill: color
  }), __jsx("path", {
    d: "M2.5 0.5C1.11929 0.5 0 1.61929 0 3V13C0 14.3807 1.11929 15.5 2.5 15.5H17.5C18.8807 15.5 20 14.3807 20 13V3C20 1.61929 18.8807 0.5 17.5 0.5H2.5ZM1.25 3C1.25 2.30964 1.80964 1.75 2.5 1.75H17.5C18.1904 1.75 18.75 2.30964 18.75 3V13C18.75 13.6904 18.1904 14.25 17.5 14.25H11.1994C11.2327 14.0459 11.25 13.8372 11.25 13.625C11.25 11.2088 9.01142 9.25 6.25 9.25C3.64211 9.25 1.50054 10.997 1.27047 13.2265C1.25702 13.153 1.25 13.0773 1.25 13V3Z",
    fill: color
  }));
};
export default VCardIcon;